module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body",
    attrs: {
      "translate": "no"
    }
  }, [_c('div', {
    staticClass: "content-404"
  }, [_c('canvas', {
    staticClass: "snow",
    attrs: {
      "id": "snow",
      "width": "1349",
      "height": "400"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-text"
  }, [_c('h1', [_vm._v("天啊。"), _c('br'), _vm._v("那页失踪了。")]), _vm._v(" "), _c('div', {
    staticClass: "main-text-a"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" 返回首页")])])]), _vm._v(" "), _c('div', {
    staticClass: "ground"
  }, [_c('div', {
    staticClass: "mound"
  }, [_c('div', {
    staticClass: "mound_text"
  }, [_vm._v("404 ")]), _vm._v(" "), _c('div', {
    staticClass: "mound_spade"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97ed9d2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/errorPages/Page404.vue
// module id = 1096
// module chunks = 284